import { DownOutlined, FilterOutlined } from '@ant-design/icons';
import { useSearchParams } from 'react-router-dom';

import { MultipleSelect } from '@app/components';
import { MOBILE } from '@app/constants';
import { useWindowSize } from '@app/hooks';
import { generateSpanWithDataTestId } from '@app/shared/utils';

import type { NWorkSchedule } from '@pages/WorkSchedule/WorkSchedule.types';

import type { BaseOptionType } from 'antd/es/select';

export const ScheduleSidebar: NWorkSchedule.Sidebar = ({
  allPositions,
  selectedPositions,
  employees,
  positionsLoader,
  filterByEmployees,
}) => {
  const { innerWidth = 0 } = useWindowSize() ?? {};
  const [searchParams] = useSearchParams();

  return (
    <div className="sidebar">
      <div style={{ marginBottom: 27, marginTop: 25, marginRight: 25 }}>
        <MultipleSelect
          disabled={!!searchParams.get('employee-id')}
          loader={positionsLoader}
          className="position-select"
          dropdownDataTestId="position-dropdown"
          optionDataTestId="position-item"
          placeholder={
            innerWidth <= 755 ? (
              <FilterOutlined />
            ) : (
              generateSpanWithDataTestId('Все должности', 'all-positions')
            )
          }
          allOptions={(allPositions || []).map(
            ({ Id, Name }: BaseOptionType) => ({
              value: Id,
              label: Name,
            })
          )}
          width={0}
          selectedOption={selectedPositions}
          defaultSelected
          setSelectedOptions={(values: BaseOptionType[]) =>
            filterByEmployees(values, employees)
          }
          suffixIcon={innerWidth <= MOBILE ? null : <DownOutlined />}
        />
      </div>
    </div>
  );
};
